import React, {useEffect, useState} from "react";
import {Breadcrumbs, Card, Typography, Link, Alert} from "@mui/joy";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import InfoIcon from '@mui/icons-material/Info';
import {ToastContainer} from "react-toastify";
import FranchiseFeesTable from "../tables/FranchiseFeesTable";
import GeneralApiService from "../../axios/Axios";

export default function FranchiseFees() {
    const [estimatedFee, setEstimatedFee] = useState<number | null>(null);
    const location = localStorage.getItem('location');

    useEffect(() => {
        if (location === 'All') {
            GeneralApiService.getEstimatedFranchiseFees()
                .then((data: any) => setEstimatedFee(data.estimated_fee))
                .catch(console.error);
        }
    }, [location]);

    return (
        <>
            <ToastContainer />
            <Breadcrumbs size="sm" aria-label="breadcrumbs" separator={<ChevronRightRoundedIcon />} sx={{ pl: 0, mb: 1 }}>
                <Link underline="none" color="neutral" href="/dashboard" aria-label="Home"><HomeRoundedIcon /></Link>
                <Link underline="hover" color="neutral" href="/dashboard" fontSize={12} fontWeight={500}>Dashboard</Link>
                <Typography color="primary" fontWeight={500} fontSize={12}>Franchise Fees</Typography>
            </Breadcrumbs>

            <Card>
                <Typography level="h3" sx={{mb: 1}}>Franchise Fees</Typography>
                
                {location === 'All' && estimatedFee !== null && (
                    <Alert startDecorator={<InfoIcon />} variant="soft" color="primary" sx={{ mb: 2 }}>
                        <Typography fontWeight="lg">
                            Next Month Estimated Franchise Fees: £{estimatedFee.toFixed(2)}
                        </Typography>
                    </Alert>
                )}

                <Typography level="body-sm" color="neutral" sx={{mb: 2}}>
                    Monthly franchise fees (10% of last month’s booked revenue). If a card is on file, fees auto-charge; otherwise pay via the link or the button below.
                </Typography>
                <FranchiseFeesTable />
            </Card>
        </>
    );
}
